import React, { useState, useEffect } from "react";
import Hero from "../components/Hero";
import ClaimsStrip from "../components/ClaimsStrip";
import FlavourGrid from "../components/FlavourGrid";
import ThreePillars from "../components/ThreePillars";
import FounderScroll from "../components/FounderScroll";
import BundleUpsell from "../components/BundleUpsell";
import Reviews from "../components/Reviews";
import LeadCaptureModal from "../components/LeadCaptureModal";

export default function Home() {
  const [showLeadModal, setShowLeadModal] = useState(false);

  useEffect(() => {
    const hasCapturedLead = localStorage.getItem("km_lead_email");
    const hasDismissedPopup = sessionStorage.getItem("km_popup_dismissed");

    if (!hasCapturedLead && !hasDismissedPopup) {
      const timer = setTimeout(() => {
        setShowLeadModal(true);
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => {
    setShowLeadModal(false);
    sessionStorage.setItem("km_popup_dismissed", "true");
  };

  return (
    <div data-testid="home-page">
      <Hero />
      <ClaimsStrip />
      <FlavourGrid />
      <ThreePillars />
      <FounderScroll />
      <BundleUpsell />
      <Reviews />

      <LeadCaptureModal
        isOpen={showLeadModal}
        onClose={handleClose}
        onSuccess={() => setShowLeadModal(false)}
        triggerSource="popup"
      />
    </div>
  );
}